import React from 'react';

interface Props {
    onMenuOpen: () => void;
};

const Header = (props: Props) => {
    return (
	<div className="header">
	    <div className="sides">
		<div className="side left" />

		<div className="side center">
		    <div className="motto">
			<div className="icon lock" />
			<span>encrypted, local, yours forever</span>
		    </div>
		</div>

		<div className="side right">
		    <div className="menuToggle" onClick={props.onMenuOpen}>
			<div className="icon sandwich" />
		    </div>
		</div>
	    </div>
	</div>
    );
};

export default Header;